import { motion } from "framer-motion";
import env from "@/assets/images/economy.png";

export default function EconomicImpact() {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-linear-to-b from-green-50 to-white overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left side - Animated Content */}
          <motion.div
            className="space-y-6 text-left"
            initial={{ opacity: 0, x: -80 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.9, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <div>
              <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4 tracking-tight">
                Economic Impact
              </h2>
              <div className="w-16 h-1.5 bg-emerald-500 rounded-full"></div>
            </div>

            <p className="text-base sm:text-lg lg:text-xl text-slate-600 leading-relaxed">
              Food waste costs the global economy{" "}
              <span className="font-bold text-emerald-600">
                over $1 trillion
              </span>{" "}
              every year. By turning surplus food into affordable{" "}
              <span className="font-bold text-emerald-600">Mystery Bags</span>,
              SMARTLY ORDERS helps businesses recover revenue while giving
              customers access to great food at unbeatable prices.
            </p>
          </motion.div>

          {/* Right side - Animated Image */}
          <motion.div
            className="flex justify-center"
            initial={{ opacity: 0, x: 80 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.9, ease: "easeOut", delay: 0.2 }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <motion.div
              className="w-full max-w-lg rounded-2xl overflow-hidden"
              whileHover={{
                scale: 1.03,
              }}
              animate={{ y: [0, -10, 0] }}
              transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
            >
              <img
                src={env}
                alt="Economic Impact"
                className="w-full h-full object-cover"
              />
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
